import React from "react";
import PropTypes from "prop-types";
import VariantSelectorContainer from "core-web/containers/VariantSelectorContainer";
import ProductVariants from "theme/components/Variants/ProductVariants";

const ProductVariantSelector = ({
    callback,
    variants,
    selectedVariant,
    productId,
    layout,
    getSelectedParametrics,
    ...props
}) => {
    return (
        <VariantSelectorContainer
            callback={callback}
            getSelectedParametrics={getSelectedParametrics}
            variants={variants}
            productId={productId}
            selectedVariant={selectedVariant}
            render={({
                selections,
                selectedParametrics,
                selectParametricValue,
                checkStockStatus,
                checkPossibleSelection,
                getVariantByParametricSelection,
            }) => (
                <ProductVariants
                    layout={layout}
                    variants={selections}
                    selectParametricValue={selectParametricValue}
                    selectedParametrics={selectedParametrics}
                    selectedVariant={selectedVariant}
                    checkPossibleSelection={checkPossibleSelection}
                    checkStockStatus={checkStockStatus}
                    getVariantByParametricSelection={getVariantByParametricSelection}
                    {...props}
                />
            )}
        />
    );
};

ProductVariantSelector.propTypes = {
    callback: PropTypes.func.isRequired,
    getSelectedParametrics: PropTypes.func,
    layout: PropTypes.string,
    productId: PropTypes.number.isRequired,
    selectedVariant: PropTypes.object,
    variants: PropTypes.array.isRequired,
};

ProductVariantSelector.defaultProps = {
    getSelectedParametrics: () => null,
    layout: "blocks",
    selectedVariant: null,
};

export default ProductVariantSelector;
